import {action, makeAutoObservable} from 'mobx';
import {IMessage} from 'models/chat';
import WebRTCWebSockets from 'services/WebRTCWebSockets';
import {UserStore} from './UserStore';

export class ChatStore {
  private webSocket: WebRTCWebSockets | undefined;
  private userStore: UserStore;
  private isChatListActive = false;

  hasUnreadMessages: boolean = false;
  message: string = '';
  chatMessages: IMessage[] = [];

  constructor(userStore: UserStore) {
    this.userStore = userStore;
    makeAutoObservable(this);
  }

  setHasUnreadMessages = (value: boolean) => {
    this.hasUnreadMessages = value;
  };

  setIsChatListOpened = (active: boolean) => {
    if (active) {
      this.setHasUnreadMessages(false);
    }

    this.isChatListActive = active;
  };

  configure = (webSocket: WebRTCWebSockets) => {
    this.webSocket = webSocket;

    this.webSocket.onMessageReceived = (fromConnectionId, data) => {
      const messageData = JSON.parse(data);
      if (messageData.nickname != this.userStore.fullUserName) {
        !this.isChatListActive && this.setHasUnreadMessages(true);
        this.setNewChatMessage(messageData.message, messageData.nickname);
      }
    };
  };

  disconnect = () => {
    this.webSocket = undefined;
    this.chatMessages = [];
    this.message = '';
  };

  setMessage = (message: string) => {
    this.message = message;
  };

  setNewChatMessage = (message: string, username: string) => {
    const chatMessages = [...this.chatMessages];
    chatMessages.unshift({
      id: this.chatMessages.length + 1,
      text: message,
      createdAt: new Date(),
      isMyMessage: this.userStore.fullUserName == username,
      user: {
        name: username,
      },
    });

    this.chatMessages = chatMessages;
  };

  sendMessage = () => {
    this.webSocket?.sendSendMessage(this.message);
    this.setNewChatMessage(this.message, this.userStore.fullUserName);
    this.message = '';
  };
}
